import { PrimaryButton } from '@/lib';

export function AssignmentStep({ onCompleted }: { onCompleted: () => void }) {
  return (
    <div className="flex flex-col gap-sp-4">
      <p className="text-fs-body text-gray-700">
        Connect each sensor to an asset and the position on that
        asset (e.g. DE bearing, motor stator).
      </p>
      <p className="text-fs-meta text-gray-700">
        Use the Commissioning wizard at{' '}
        <a className="text-info hover:underline" href="/commissioning">
          /commissioning
        </a>{' '}
        for the drag-drop UI. Skippable for now if no sensors are
        physically deployed yet.
      </p>
      <PrimaryButton label="Sensors assigned" onClick={onCompleted} />
    </div>
  );
}
